/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import {InertiaApp} from '@inertiajs/inertia-vue'
import VueChatScroll from 'vue-chat-scroll'
import Vue from 'vue';
import phoneInputHandler from './services/phone-input-handler';

// Make phone input handler globally available
window.phoneInputHandler = phoneInputHandler;

window.Vue = require('vue').default;
Vue.use(VueChatScroll)
Vue.use(InertiaApp)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 
 const app = document.getElementById('app')
 
 new Vue({
     render: h => h(InertiaApp, {
         props: {
             initialPage: JSON.parse(app.dataset.page),
             resolveComponent: name => require(`./components/${name}`).default,
         },
     }),
 }).$mount(app)

